<script>
import ItemCards from "@/router/views/office/office-widgets/item-cards.vue";
import { cloneDeep } from "lodash";
export default {
    components: {
        ItemCards,
    },
    props: {
        multiple: {
            type: Boolean,
            default: false,
        },
    },
    name: "ItemList",
    data() {
        return {
            submitted: false,
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: "",
            filterOn: ["itemName"],
            sortBy: "itemName",
            sortDesc: false,
            fields: [
                {
                    key: "itemCode",
                    thStyle: { width: "100px" },
                },
                {
                    key: "itemName",
                    sortable: true,
                },
                {
                    key: "inDbm",
                    thStyle: { width: "100px" },
                    sortable: true,
                },
                {
                    key: "cost",
                    label: "Unit Cost",
                    sortable: true,
                    thStyle: { width: "180px" },
                },
            ],
            indexSelected: -1,
            tableBusy: false,
            categories: [],
            searchItem: null,
            remainingResult: 0,
            startPage: 0,
            loadingMore: false,
        };
    },
    computed: {
        filteredItems() {
            let data = this.tableData;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.searchItem
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            // var currentData = data.slice(total - this.perPage, total);
            // if (this.currentPage > 1 && currentData.length == 0) {
            //     total = (this.currentPage - 1) * this.perPage;
            //     currentData = data.slice(total - this.perPage, total);
            // }
            return data;
        },
        rows() {
            let data = this.tableData;
            if (this.filter) {
                if (this.filter.trim() != "" && this.filter) {
                    data = data.filter((item) => {
                        return item.searchItem
                            .toUpperCase()
                            .includes(this.filter.toUpperCase());
                    });
                }
            }
            return data.length;
        },
        getSelected(){
            return this.tableData.filter(item => item.checkItem);
        }
    },
    created(){
        this.getItemCategories();
    },
    methods: {
        async getItemCategories(){
            await this.$store
                .dispatch("itemcategory/GetItemCategory")
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.categories = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        onSelected(data) {
            this.$emit("dropData", data);
            this.$bvModal.hide("item-list-modal");
        },
        changeCycle(cycle) {
            this.tableBusy = true;
            this.tableData = [];
            this.$store
                .dispatch("item/GetItemByCycle", {cycle, campusId: this.$store.state.data.selectedCampus.id})
                .then((res) => {
                    this.tableBusy = false;
                    res.data.map((item) => {
                        item.checkItem = false;
                        item.descriptionClicked = false;
                        item.cost = this.formatCurrency(item.unitCost);
                        item.filterKey = `${item.itemName} ${item.description}`;
                    });
                    this.tableData = res.data;
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        async getAllItems(){
            this.tableBusy = true;
            this.tableData = [];
            this.remainingResult = 0;
            if(this.searchItem && this.searchItem.search.trim() == ""){
                this.tableBusy = false;
                return;
            }
            await this.$store
                .dispatch("item/SearchItem", {
                    ...this.searchItem,
                    year: this.$store.state.data.cycle,
                    campusId: this.$store.state.data.selectedCampus.id,
                    lastId: 0,
                    removeLoading: true,
                })
                .then((res) => {
                    if(res.data.error){
                        this.tableBusy = false;
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.tableBusy = false;
                    res.data.results.map((item) => {
                        item.checkItem = false;
                        item.descriptionClicked = false;
                        item.cost = this.formatCurrency(item.unitCost);
                        item.filterKey = `${item.itemName} ${item.description}`;
                        let category = cloneDeep(item.itemCategory);
                        item.itemCategory = {
                            id: item.itemCategoryId,
                            name: category
                        }
                        let un = cloneDeep(item.unit);
                        item.unit = {
                            id: item.unitId,
                            shortName: un
                        }
                    });
                    this.tableData = res.data.results;
                    this.remainingResult = res.data.remainingResult;
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast(
                        "Something went wrong! - getting Item",
                        "error"
                    );
                });
        },
        async loadMoreItems(){
            this.startPage++;
            this.loadingMore = true;
            try{
                const { data: response } = await this.$store.dispatch("item/SemanticSearch", {
                    body: this.searchItem.search,
                    page: this.startPage,
                    year: this.$store.state.data.cycle,
                    campusId: this.$store.state.data.selectedCampus.id,
                    removeLoading: true,
                });
                if(response.error){
                    return this.showToast(response.errorMessage, "error");
                }
                response.results.forEach((item) => {
                    item.descriptionClicked = false;
                    item.cost = this.formatCurrency(item.unitCost);
                    item.thumbnailUrl = item.thumbnail ? `${this.$store.state.data.rootFileDirectory}Procurement/${item.thumbnail}` : '';
                    item.filterKey = `${item.itemName} ${item.description}`;
                    item.selected = false;
                    item.trimmedItemName = item.itemName.trim().replace(/\s/g, "")
                    item.itemCategory = {
                        id: item.itemCategoryId,
                        name: item.itemCategory
                    }
                    item.unit = {
                        id: item.unitId,
                        shortName: item.unit
                    }
                });
                this.tableData = this.tableData.concat(response.results);
                this.remainingResult = response.remainingResult;
            }catch(error){
                this.showToast("Something went wrong! - getting Item", "error");
            }
            this.loadingMore = false;
        },
        getItemByAccount(id){
            this.tableBusy = true;
            this.tableData = [];
            this.$store
                .dispatch("item/GetItemByAccount",  id)
                .then((res) => {
                    this.tableBusy = false;
                    res.data.map((item) => {
                        item.checkItem = false;
                        item.cost = this.formatCurrency(item.unitCost);
                        item.searchItem = `${item.itemName} ${item.description}`;
                    });
                    res.data.sort(function(a, b){
                        if(a.itemName < b.itemName) { return -1; }
                        if(a.itemName > b.itemName) { return 1; }
                        return 0;
                    })
                    this.tableData = res.data;
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        downloadItems(){
            this.$emit("dropData", this.getSelected);
            this.$bvModal.hide("item-list-modal");
        },
        async searchAction(search){
            this.searchItem = search;
            // this.getItems(this.$store.state.data.cycle);
            this.tableBusy = true;
            this.tableData = [];
            this.startPage = 0;
            this.remainingResult = 0;
            await this.semanticSearch(search);
            this.tableBusy = false;
        },
        async semanticSearch(search){
            try{
                const { data: response } = await this.$store.dispatch("item/SemanticSearch", {
                    body: search.search,
                    year: this.$store.state.data.cycle,
                    campusId: this.$store.state.data.selectedCampus.id,
                    removeLoading: true,
                });
                if(response.error){
                    return this.showToast(response.errorMessage, "error");
                }
                this.tableData = response.results.map((item) => {
                    item.descriptionClicked = false;
                    item.cost = this.formatCurrency(item.unitCost);
                    item.thumbnailUrl = item.thumbnail ? `${this.$store.state.data.rootFileDirectory}Procurement/${item.thumbnail}` : '';
                    item.filterKey = `${item.itemName} ${item.description}`;
                    item.selected = false;
                    item.trimmedItemName = item.itemName.trim().replace(/\s/g, "")
                    item.itemCategory = {
                        id: item.itemCategoryId,
                        name: item.itemCategory
                    }
                    item.unit = {
                        id: item.unitId,
                        shortName: item.unit
                    }
                    return item;
                });
                this.remainingResult = response.remainingResult;
            }catch(error){
                this.showToast("Something went wrong! - getting Item", "error");
            }
        },
    },
};
</script>

<template>
    <b-modal
        id="item-list-modal"
        title="Item List"
        size="xl"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <ItemCards 
            :selectable="true" 
            :items="tableData" 
            :perPage="10" 
            @selected-item="onSelected" 
            :withFilter="true" 
            :categories="categories"
            :remainingResult="remainingResult"
            @search-item="searchAction"
            @load-more="loadMoreItems"
            :loadingMore="loadingMore"
            :busy="tableBusy"
        />
        <!-- <div class="row mt-1">
            <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter">
                    <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                            autocomplete="off"
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                        ></b-form-input>
                    </label>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 text-right">
                <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                    </label>
                </div>
            </div>
        </div>
        <div class="table-responsive mb-0">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th style="width: 50px" v-if="multiple"></th>
                        <th class="no-wrap">Item Name</th>
                        <th class="text-center no-wrap">In DBM</th>
                        <th class="no-wrap">Cost</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="tableBusy">
                        <td :colspan="multiple ? '4' : '3'" class="text-center">
                            <div
                                class="
                                    d-flex
                                    justify-content-center
                                    align-items-center
                                "
                            >
                                <div class="preloader-component me-2">
                                    <div class="status">
                                        <div
                                            class="spinner-chase w-20px h-20px"
                                        >
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                        </div>
                                    </div>
                                </div>
                                <strong>Loading...</strong>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="!tableBusy && tableData.length == 0">
                        <td :colspan="multiple ? '4' : '3'" class="text-center">
                            No data found...
                        </td>
                    </tr>
                    <tr
                        v-if="
                            !tableBusy &&
                            tableData.length > 0 &&
                            filteredItems.length == 0
                        "
                    >
                        <td :colspan="multiple ? '4' : '3'" class="text-center">
                            Search found...
                        </td>
                    </tr>
                    <tr v-for="row in filteredItems" :key="row.id" class="cursor-pointer" @click="onRowSelected(row)">
                        <td v-if="multiple" class="align-middle">
                            <div class="d-flex justify-content-center">
                                <div
                                    class="
                                        form-check
                                        form-checkbox-outline
                                        form-check-success
                                        mb-0
                                    "
                                >
                                    <input
                                        type="checkbox"
                                        :id="`customCheckcolor${row.id}`"
                                        class="form-check-input"
                                        v-model="row.checkItem"
                                    />
                                </div>
                            </div>
                        </td>
                        <td class="align-middle">
                            <div>{{ row.itemName }}</div>
                            <small>{{ row.description }}</small>
                        </td>
                        <td class="align-middle text-center">
                            {{ row.inDbm ? "Yes" : "No" }}
                        </td>
                        <td class="align-middle">
                            <div>{{ row.cost }}</div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row">
            <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                    <ul class="pagination pagination-rounded mb-0">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
        <div class="position-fixed" style="bottom: 50px; right: 50px">
            <div
                class="position-relative"
                v-if="
                    getSelected.length > 0 
                "
            >
                <button
                    class="
                        btn btn-success
                        d-flex
                        align-items-center
                        rounded-pill
                    "
                    type="button"
                    @click="downloadItems"
                >
                    <i class="bx bx-download font-size-18 me-1"></i
                    ><span>Add {{getSelected.length > 1 ? 'Items' : 'Item'}}</span>
                </button>
                <small
                    class="position-absolute badge bg-danger"
                    style="top: -5px; right: 0; z-index: 10px"
                    >{{ getSelected.length }}</small
                >
            </div>
        </div> -->
    </b-modal>
</template>